import React, { useState, useMemo, useEffect } from 'react'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { ContextDataChip } from '@tecuity/granite-ui/ContextDataChip'
import { ContextBar } from '@tecuity/granite-ui/ContextBar'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { Detail } from '@tecuity/granite-ui/Detail'
import { MoreOptionsButton } from '@tecuity/granite-ui/MoreOptionsButton'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import RightArrowIcon from '@tecuity/sos-icons/react/right-arrow'
import LeftArrowIcon from '@tecuity/sos-icons/react/left-arrow'
import PlusIcon from '@tecuity/sos-icons/react/plus-heavy'
import Revert from '@tecuity/sos-icons/react/revert'
import PrintIcon from '@tecuity/sos-icons/react/print-solid'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'
import ReceiptCancel from '@tecuity/sos-icons/react/receipt-cancel'
import Clone from '@tecuity/sos-icons/react/clone'
import ReceiptCharge from './ReceiptCharge'
import ReceiptPayment from './ReceiptPayment'
import ChargeModal from './ChargeModal'
import PaymentModal, { defaultPayment } from './PaymentModal'
import './ReceiptValidation.scss'
import format from 'date-fns/format'
import { useHistory, useLocation } from 'react-router'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { getUSADefault } from '../../Wizard2/selectOptions'
import {
  getDbReceiptDetails,
  updateReceipt,
  getReceiptItemTypes,
  getCurrentUser,
  getReceiptItemTypeEnum,
  getDLNs,
  voidReceipt,
  getRefundStatus,
  tieReceiptToImageEnvelope
} from './ReceiptValidationActions'
import { CLEAR_RECEIPT, REVERT_RECEIPT, SET_RECEIPT } from './ReceiptValidationReducer'
import { ADD_PDF_TO_LIST, pdfTypes } from '../../ReportViewer/ReportViewerReducer'
import { shouldPopulateEnvelopeReports } from '../../ReportViewer/ReportViewerActions'
import { toggleSidebarCollapse, overrideSidebarResizing } from '../../../actions'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import { openSpecificImage } from '../../ImageViewer/ImageViewerActions'
import { APPROVE_FILING_BY_WORKVIEW_ITEM_ID } from '../../../requests'
import { Spinner } from '../../Loaders/Loaders'
import Refund, { RefundModal } from './Refund'
import { setErrorToast } from '../../../actions'
import { FilingSourceTypeIds } from '../../../Utilities/Utilities'
import * as api from '../../../requests'

const ReceiptValidation = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const {
    receipt,
    failedValidation,
    originalReceipt,
    currentUser = {},
    workviewItem = {},
    isCorrespondence = false,
    receiptItemTypes = [],
    redirectBackTo,
    loadingExisting = false,
  } = useSelector((state) => state.receipt, shallowEqual)
  const { windowInstance } = useSelector((state) => state.imageViewer, shallowEqual)
  const { WEB_USER_ID, FIRST_NAME, LAST_NAME, appUserRights } = useSelector(
    (state) => state.auth,
    shallowEqual
  )
  const [chargesList, setChargesList] = useState([])
  const [paymentsList, setPaymentsList] = useState([])
  const [chargeModalOpen, setChargeModalOpen] = useState(false)
  const [editCharge, setEditCharge] = useState(null)
  const [paymentModalOpen, setPaymentModalOpen] = useState(false)
  const [editPayment, setEditPayment] = useState(null)
  const [editIndex, setEditIndex] = useState(null)
  const [displayBalanceError, setDisplayBalanceError] = useState(false)
  const [displayEmptyReceiptError, setDisplayEmptyReceiptError] = useState(false)
  const [displayUnbalancedError, setDisplayUnbalancedError] = useState(false)
  const [displayWorkviewBalanceError, setDisplayWorkviewBalanceError] = useState(false)
  const [displayMoreButton, setDisplayMoreButton] = useState(false)
  const [displayDeleteItemConfirmation, setDisplayDeleteItemConfirmation] = useState(false)
  const [loadingWorkviewPayment, setLoadingWorkviewPayment] = useState(false)
  const [voidModalOpen, setVoidModalOpen] = useState(false)
  const [voidReason, setVoidReason] = useState('')
  const [voidPopupError, setVoidPopupError] = useState(false)
  const [isDirty, setIsDirty] = useState(false)
  const [canEditCharges, setCanEditCharges] = useState(true)
  const [refundInfo, setRefundInfo] = useState({})
  const [editRefundInfo, setEditRefundInfo] = useState(false)
  const [showRevert, setShowRevert] = useState(false)
  const [refundModal, setRefundModal] = useState(false)
  const [saveRefund, setSaveRefund] = useState(false)
  const [saveInProgress, setSaveInProgress] = useState(false)
  const [depositToAccountName, setDepositToAccountName] = useState('')
  const [reverseCreditCardReceiptItemId, setReverseCreditCardReceiptItemId] = useState(0)
  const [reverseCheckReceiptItemId, setReverseCheckReceiptItemId] = useState(0)
  const [populateOnEnvelopeCompletion, setPopulateOnEnvelopeCompletion] = useState(false)

  const moreButtonRights = () => {
    return (
      appUserRights.includes('ReceiptCreate') ||
      appUserRights.includes('ReceiptCreate') ||
      appUserRights.includes('ReceiptVoid')
    )
  }

  const receiptNum = useMemo(() => {
    const parts = location.pathname.split('/')
    return parts[parts.length - 1]
  }, [location.pathname])

  useEffect(() => {
    if (receiptNum && receiptNum !== 'receipt') {
      dispatch(getDbReceiptDetails(receiptNum))
    } else if (workviewItem && workviewItem.ImageGroupId) {
      setLoadingWorkviewPayment(true)
      dispatch(
        getDLNs(workviewItem, (dlns) => {
          LoadDLNs(dlns)
        })
      )
    }
  }, [receiptNum])

  useEffect(() => {
      //DepositToAccountReceiptItemTypeName
      api.GET_APP_SETTING_BY_NAME(
        'DepositToAccountReceiptItemTypeName',
        (res) => {
          setDepositToAccountName(res.VALUE)
        },
        (err) => {
          console.error(err)
        }
      )
    }, [])

  useEffect(() => {
      //Reverse Receipt Item Types
      api.GET_APP_SETTING_BY_NAME(
        'ReverseCreditCardReceiptItemTypeId',
        (res) => {
          setReverseCreditCardReceiptItemId(res.VALUE)
        },
        (err) => {
          console.error(err)
        }
      )
      api.GET_APP_SETTING_BY_NAME(
        'ReverseCheckReceiptItemTypeId',
        (res) => {
          setReverseCheckReceiptItemId(res.VALUE)
        },
        (err) => {
          console.error(err)
        }
      )
    }, [])
  
  useEffect(() => {
    api.GET_APP_SETTING_BY_NAME(
      'PopulateReportViewerOnEnvelopeCompletion',
      (res) => {
        setPopulateOnEnvelopeCompletion(!!res && String(res.VALUE).toLowerCase() === 'true')
      },
      (err) => {
        console.error(err)
        setPopulateOnEnvelopeCompletion(false)
      }
    )
  }, [])

  useEffect(() => {
    dispatch(overrideSidebarResizing(true))
    dispatch(toggleSidebarCollapse(true))
    dispatch(getReceiptItemTypes())
    dispatch(getCurrentUser(WEB_USER_ID))
    dispatch(getReceiptItemTypeEnum())
    dispatch(getRefundStatus())
    return () => {
      dispatch(overrideSidebarResizing(false))
      dispatch(toggleSidebarCollapse(false))
      dispatch({ type: CLEAR_RECEIPT })
    }
  }, [])

  useEffect(() => {
    setPaymentsList(receipt.Payments || [])
    setChargesList(receipt.Charges || [])
    receipt.ReceiptNum ? setDisplayMoreButton(true) : setDisplayMoreButton(false)
  }, [receipt])

  const updateChargeItem = (item) => {
    if (editIndex !== null) {
      setChargesList(chargesList.map((charge, i) => (i === editIndex ? item : charge)))
    } else {
      setChargesList([...chargesList, item])
    }

    setEditIndex(null)
    setChargeModalOpen(false)
    setEditCharge({})
    setIsDirty(true)
    setShowRevert(true)
  }

  const openChargeModal = (charge = { Quantity: 1 }, chargeIndex = null) => {
    setEditCharge(charge)
    setEditIndex(chargeIndex)
    setChargeModalOpen(true)
  }

  const updatePaymentItem = (item) => {
    if (editIndex !== null)
      setPaymentsList(paymentsList.map((payment, i) => (i === editIndex ? item : payment)))
    else setPaymentsList([...paymentsList, item])

    setPaymentModalOpen(false)
    setEditIndex(null)
    setEditPayment({})
    setIsDirty(true)
    setShowRevert(true)
  }

  const openPaymentModal = (payment = { Quantity: 1 }, paymentIndex = null) => {
    setEditPayment(payment)
    setEditIndex(paymentIndex)
    setPaymentModalOpen(true)
  }

  const revertReceipt = () => {
    setEditRefundInfo(false)
    if (receipt.ReceiptNum) dispatch(getDbReceiptDetails(receipt.ReceiptNum))
    else if (originalReceipt.ReceiptNum) dispatch(getDbReceiptDetails(originalReceipt.ReceiptNum))
    else dispatch({ type: REVERT_RECEIPT })
    setIsDirty(false)
    setCanEditCharges(true)
  }

  const LoadDLNs = (dlns) => {
    let paymentsList = []
    dlns.forEach((element) => {
      if (element.Type.TypeDesc == 'Payment') {
        paymentsList.push({
          ...defaultPayment,
          Payor: { ...defaultPayment.Payor, Country: getUSADefault() },
          DLNNum: element.DLN,
          Type: { Description: `Payment - Check/MO`, ReceiptItemTypeId: `2` },
        })
      }
    })
    setPaymentsList(paymentsList)
    setLoadingWorkviewPayment(false)
  }

  const printReceipt = () => {
    dispatch({
      type: ADD_PDF_TO_LIST,
      pdfInfo: {
        filename: `Receipt-${receipt.ReceiptNum}.pdf`,
        type: pdfTypes.RECEIPT,
        ReceiptNum: receipt.ReceiptNum,
      },
    })
  }

  const afterSaveStuff = (imageDataTypeNotHandled = true, newData) => {
    if (imageDataTypeNotHandled && balanceValue == 0) {
      dispatch({
        type: ADD_PDF_TO_LIST,
        pdfInfo: {
          filename: `Receipt-${newData.ReceiptNum}.pdf`,
          type: pdfTypes.RECEIPT,
          ReceiptNum: newData.ReceiptNum,
        },
      })
    }
    if (windowInstance && windowInstance.location && windowInstance.location.reload) {
      windowInstance.location.reload()
    }
    if (workviewItem) {
      dispatch(openSpecificImage(workviewItem.ImageEnvelopeId, workviewItem.DLN))
      history.push('/office/workview')
    } else if (isCorrespondence) {
      history.push('/office/workview')
    }
    setIsDirty(false)
    setSaveRefund(false)
    setSaveInProgress(false)
  }

  const saveReceipt = () => {
    setEditRefundInfo(false)

    if (disableSaveButton) return

    let valid = true
    const balancePayment = paymentsList.find(
      (item) => item.WaivedYN === 'Y' || item.WaivedYN === true
    )
    const balanceCharge = chargesList.find(
      (item) => item.WaivedYN === 'Y' || item.WaivedYN === true
    )

    if ((balancePayment || balanceCharge) && +balanceValue != 0) {
      valid = false
      setDisplayUnbalancedError(true)
    }

    if (balanceValue < 0) {
      valid = false
      setDisplayBalanceError(true)
    }

    if (paymentsList.length === 0 && chargesList.length === 0) {
      valid = false
      setDisplayEmptyReceiptError(true)
    }

    if (receipt.isLastImageGroup && (balanceValue !== 0 || chargesList.length === 0)) {
      valid = false
      setDisplayWorkviewBalanceError(true)
    }

    if (valid) {
      setSaveInProgress(true)
      dispatch(
        updateReceipt(
          {
            ...receipt,
            ReceiptID: receipt.ReceiptID || 0,
            Payments: paymentsList.map((payment) => ({
              ...payment,
              ReceiptID: payment.ReceiptID || 0,
              ReceiptItemID: payment.ReceiptItemID || 0,
            })),
            Charges: chargesList.map((charge) => ({
              ...charge,
              ReceiptID: charge.ReceiptID || 0,
              ReceiptItemID: charge.ReceiptItemID || 0,
            })),
            Fields: {
              ...receipt.Fields,
              LAST_MODIFIED_APP_USER_ID: currentUser.App_User_ID,
            },
            StatusID: receipt.StatusID || 516, // default for saving new receipts.
          },
          (newData) => {
            const maybePopulateEnvelopeReports = (isEnvelopeComplete) => {
              if (
                populateOnEnvelopeCompletion &&
                shouldPopulateEnvelopeReports({
                  isEnvelopeComplete,
                  hasReceipt: true,
                  isReceiptBalanced: balanceValue === 0,
                })
              ) {
                dispatch({
                  type: ADD_PDF_TO_LIST,
                  pdfInfo: {
                    filename: `Envelope-${workviewItem.ImageEnvelopeId}.pdf`,
                    type: pdfTypes.IMAGE_ENVELOPE,
                    imageEnvelopeId: workviewItem.ImageEnvelopeId,
                  },
                })
              }
            }
            if (workviewItem) {
              if (workviewItem.SourceTypeId === FilingSourceTypeIds.Receipt) {
                // We don't want to activate amendment for payments
                dispatch(
                  tieReceiptToImageEnvelope(
                    newData,
                    workviewItem,
                    () => {
                      const finishReceiptOnly = (data) => {
                        afterSaveStuff(!populateOnEnvelopeCompletion, data)
                        maybePopulateEnvelopeReports(receipt.IsEnvelopeComplete === true)
                      }
                      if (newData.Charges.find(item => item.Type.Description === depositToAccountName && item.FrequentPayorID > 0))
                      {
                        // Call new endpoint.
                        api.CREATE_FREQUENT_PAYOR_DEPOSIT_FILING(
                          newData,
                          (lastData) => {
                            finishReceiptOnly(lastData || newData)
                          },
                          (err) => {
                            console.error(err)
                            finishReceiptOnly(newData)
                          }
                        )
                      }
                      else {
                        finishReceiptOnly(newData)
                      }
                    },
                    (err) => {
                      dispatch(setErrorToast(err)) //000002692
                      setSaveInProgress(false)
                    }
                  )
                )
              } else {
                APPROVE_FILING_BY_WORKVIEW_ITEM_ID(
                  workviewItem.WorkViewItemId,
                  (approvalResponse) => {
                    if (populateOnEnvelopeCompletion) {
                      afterSaveStuff(false, newData)
                      maybePopulateEnvelopeReports(approvalResponse?.IsEnvelopeComplete)
                      return
                    }
                    if (
                      workviewItem &&
                      workviewItem.SourceTypeId === FilingSourceTypeIds.Business
                    ) {
                      //'Business') {
                      afterSaveStuff(false, newData)
                      dispatch({
                        type: ADD_PDF_TO_LIST,
                        pdfInfo: {
                          filename: `Business-${
                            workviewItem.IsInitialFiling ? 'Filing' : 'Amendment'
                          }-${workviewItem.Filing.Num}.pdf`,
                          type: pdfTypes.BUSINESS_ENTITY,
                          AmendmentNum: workviewItem.Filing.Num,
                          ReceiptNum: newData.ReceiptNum,
                        },
                      })
                    } else if (
                      workviewItem &&
                      workviewItem.SourceTypeId === FilingSourceTypeIds.Orders
                    ) {
                      afterSaveStuff(false, newData)
                      dispatch({
                        type: ADD_PDF_TO_LIST,
                        pdfInfo: {
                          filename: `Order-${workviewItem.Filing.Num}.pdf`,
                          type: pdfTypes.ORDER,
                          orderNum: workviewItem.Filing.Num,
                          ReceiptNum: newData.ReceiptNum,
                        },
                      })
                    } else if (
                      workviewItem &&
                      workviewItem.SourceTypeId === FilingSourceTypeIds.Trademark
                    ) {
                      //'Trademark') {
                      afterSaveStuff(false, newData)
                      dispatch({
                        type: ADD_PDF_TO_LIST,
                        pdfInfo: {
                          filename: `Trademark-${workviewItem.Filing.Num}.pdf`,
                          type: pdfTypes.TRADEMARK,
                          trademarkAmendmentNumber: workviewItem.Filing.Num,
                          ReceiptNum: newData.ReceiptNum,
                        },
                      })
                    } else if (
                      workviewItem &&
                      workviewItem.SourceTypeId === FilingSourceTypeIds.Lien
                    ) {
                      afterSaveStuff(false, newData)
                      dispatch({
                        type: ADD_PDF_TO_LIST,
                        pdfInfo: {
                          filename: `UCC-${workviewItem.Filing.Num}.pdf`,
                          type: pdfTypes.UCC1,
                          uccAmendmentNumber: workviewItem.Filing.Num,
                          ReceiptNum: newData.ReceiptNum,
                        },
                      })
                    } else if (
                      workviewItem &&
                      workviewItem.SourceTypeId === FilingSourceTypeIds.Notary
                    ) {
                      //'Notary') {
                      afterSaveStuff(false, newData)
                      dispatch({
                        type: ADD_PDF_TO_LIST,
                        pdfInfo: {
                          filename: `Notary-${workviewItem.Filing.Num}.pdf`,
                          type: pdfTypes.NOTARY,
                          filingNum: workviewItem.Filing.Num,
                          ReceiptNum: newData.ReceiptNum,
                        },
                      })
                    } else if (
                      workviewItem &&
                      workviewItem.SourceTypeId === FilingSourceTypeIds.Apostille
                    ) {
                      //'Apostille') {
                      afterSaveStuff(false, newData)
                      dispatch({
                        type: ADD_PDF_TO_LIST,
                        pdfInfo: {
                          filename: `Apostille-${workviewItem.Filing.Num}.pdf`,
                          type: pdfTypes.APOSTILLE,
                          apostilleNum: workviewItem.Filing.Num,
                          ReceiptNum: newData.ReceiptNum,
                        },
                      })
                    } else if (workviewItem &&
                      (workviewItem.SourceTypeId === FilingSourceTypeIds.Charity ||
                        workviewItem.SourceTypeId === FilingSourceTypeIds.Contractor ||
                        workviewItem.SourceTypeId === FilingSourceTypeIds.Lobbyist ||
                        workviewItem.SourceTypeId === FilingSourceTypeIds.AthleteAgent ||
                        workviewItem.SourceTypeId === FilingSourceTypeIds.Miscellaneous)
                    ) {
                      afterSaveStuff(false, newData)
                      dispatch({
                        type: ADD_PDF_TO_LIST,
                        pdfInfo: {
                          filename: `${workviewItem.SourceTypeId}-${workviewItem.Filing.Num}.pdf`,
                          type: workviewItem.SourceTypeId,
                          filingNum: workviewItem.Filing.Num,
                          ReceiptNum: newData.ReceiptNum
                        }
                      })
                    } else {
                      afterSaveStuff(true, newData)
                    }
                  },
                  (err) => {
                    console.error(err)
                    dispatch(setErrorToast(err.Message))
                  }
                )
                if (newData.Charges.find(item => item.Type.Description === depositToAccountName && item.FrequentPayorID > 0))
                {
                  api.CREATE_FREQUENT_PAYOR_DEPOSIT_FILING(
                      newData,
                      (lastData) => {},
                      (err) => {
                        console.error(err)
                      }
                    )
                }
              }
            } else {
              afterSaveStuff(true, newData)
            }
          },
          (err) => {
            dispatch(setErrorToast(err.Message)) //000002692
            setSaveInProgress(false)
          }
        )
      )
    }
  }

  const totalCharges = useMemo(() => {
    let total = 0
    chargesList.map((item) => {
      if (item.Amount && item.Quantity) total += Number(item.Amount) * Number(item.Quantity)
      return null
    })
    return total * -1
  }, [chargesList])

  const totalPayments = useMemo(() => {
    let total = 0
    paymentsList.map((item) => {
      if (item.Amount) total += Number(item.Amount)
      return null
    })
    return total
  }, [paymentsList])

  const balanceValue = useMemo(() => {
    return totalPayments + totalCharges
  }, [totalCharges, totalPayments])

  const positiveBalanceValue = useMemo(() => {
    if (balanceValue < 0) return balanceValue * -1
    return balanceValue
  }, [balanceValue])

  const isReceiptEditable = useMemo(() => {
    if (loadingExisting) return false
    if (!currentUser || appUserRights.length === 0) return false

    if (
      receipt &&
      (receipt.Status === 'Reconciled' ||
        receipt.Status === 'Posted' ||
        receipt.Status === 'Voided')
    )
      return false

    if (receipt && receipt.VoidReason && receipt.VoidReason.Date) {
      setEditRefundInfo(false)
      return false
    }

    if (!receipt || !receipt.ReceiptID) {
      // new receipt
      // check user Right 'Create New Receipt'
      const found = appUserRights.includes('ReceiptCreate')
      return found ? true : false
    }

    if (appUserRights.includes('ReceiptCreate')) return true
    else if (receipt.Fields && currentUser.App_User_ID === receipt.Fields.CREATED_BY_APP_USER_ID) {
      // editing own receipt
      // check user Right 'Receipt Append'
      const found = appUserRights.includes('ReceiptCreate')
      return found ? true : false
    } else {
      // editing other users receipt
      // check user Right 'Receipt Append Other Users'
      const found = appUserRights.includes('ReceiptCreate')
      return found ? true : false
    }
  }, [receipt, currentUser, loadingExisting, canEditCharges])

  useEffect(() => {
    if (receipt && isReceiptEditable) {
      setShowRevert(true)
    }

    setShowRevert(false)
  }, [isReceiptEditable, receipt])

  const showVoidButton = useMemo(() => {
    if (receipt && receipt.ReceiptID && isReceiptEditable) return true
    return false
  }, [isReceiptEditable, receipt])

  const showPrintButton = useMemo(() => {
    return (
      receipt && receipt.ReceiptID && (receipt.Status === 'Posted' || receipt.Status === 'Balanced')
    )
  }, [receipt])

  const closeVoidReasonPopup = () => {
    setVoidModalOpen(false)
    setVoidReason('')
    setVoidPopupError(false)
  }

  const showBackButton = useMemo(() => {
    return redirectBackTo && true
  }, [redirectBackTo])

  const showAddReceiptItems = useMemo(() => {
    if (!receipt.Status) return true
    if (receipt.Status !== 'Posted') return true
    return false
  }, [receipt])

  useEffect(() => {
    let paymentRefund = paymentsList.find(
      (pay) => pay.ReceiptItemRefundID && pay.ReceiptItemRefundID !== 0
    )
    if (!paymentRefund) return

    setRefundInfo({
      ...paymentRefund,
      RefundID: paymentRefund.ReceiptItemRefundID,
      RefundByID: paymentRefund.RefundByID,
      RefundBy: paymentRefund.RefundBy,
      RefundDate: paymentRefund.RefundDate,
      RefundNum: paymentRefund.RefundNum,
      RefundStatusID: paymentRefund.RefundStatusID,
      RefundStatus: paymentRefund.RefundStatus,
      RefundReceiptItemID: paymentRefund.ReceiptItemID,
    })
  }, [paymentsList])

  const setRefund = (refundEdit) => {
    setSaveRefund(true)
    setShowRevert(true)
    setRefundInfo(refundEdit)
    setIsDirty(true)
    setPaymentsList(
      paymentsList.map((payment) => {
        if (payment.ReceiptItemRefundID && payment.ReceiptItemRefundID !== 0) {
          return {
            ...payment,
            ReceiptItemRefundID: refundEdit.RefundID,
            RefundByID: WEB_USER_ID,
            RefundBy: `${FIRST_NAME} ${LAST_NAME}`,
            RefundDate: new Date(refundEdit.RefundDate),
            RefundNum: refundEdit.RefundNum,
            RefundStatusID: refundEdit.RefundStatusID,
            RefundStatus: refundEdit.RefundStatus,
            RefundReceiptItemID: payment.ReceiptItemID,
          }
        } else {
          return payment
        }
      })
    )
  }

  const disableSaveButton = useMemo(() => {
    return !saveRefund && !isReceiptEditable
  }, [saveRefund, isReceiptEditable])

  const replacementCheck = () => {
    let receiptCopy = emptyReceiptFields()
    let reverseType = receiptItemTypes.Payments.find(
      (item) => item.Name.includes('Reverse') && item.Name.includes('Check')
    )
    let checkType = receiptItemTypes.Payments.find((item) => item.Name.includes('Check/MO'))
    receiptCopy.Payments[0] = {
      ...receiptCopy.Payments[0],
      Amount: receiptCopy.Payments[0].Amount * -1,
      Type: {
        ReceiptItemTypeId: reverseType.ReceiptItemTypeId,
        Description: reverseType.Name,
        CategoryID: reverseType.ReceiptItemCategoryTypeId,
      },
    }
    receiptCopy.Payments.push({
      ...defaultPayment,
      Payor: { ...receiptCopy.Payments[0].Payor },
      Type: {
        ReceiptItemTypeId: checkType.ReceiptItemTypeId,
        Description: checkType.Name,
        CategoryID: checkType.ReceiptItemCategoryTypeId,
      },
      LastModifiedBy: currentUser.App_User_ID,
    })

    receiptCopy.Charges = receiptCopy.Charges.map((item) => {
      return { ...item, Amount: 0 }
    })
    dispatch({ type: SET_RECEIPT, receipt: receiptCopy, originalReceipt: receipt })
    setPaymentsList(receiptCopy.Payments)
    setChargesList(receiptCopy.Charges)
    setCanEditCharges(false)
    setIsDirty(true)
    setShowRevert(true)
  }

  const createCancelRefundReceipt = () => {
    let receiptCopy = emptyReceiptFields()
    let refundCancelledType = (receiptItemTypes.Payments || []).find(
      (type) => +type.ReceiptItemTypeId === 190
    )
    let depositAccountType = (receiptItemTypes.Charges || []).find(
      (type) => +type.ReceiptItemTypeId === 65
    )
    receiptCopy.Charges = []
    receiptCopy.Payments = []

    // let orgRefund = paymentsList.find(pay => pay.ReceiptItemID === refundInfo.refundReceiptItemID);
    receiptCopy.Payments.push({
      ...refundInfo,
      ReceiptItemID: undefined,
      Amount: refundInfo.Amount,
      SourceID: receipt.ReceiptID,
      RefCheckNum: receipt.ReceiptNum,
      Type: {
        Description: refundCancelledType.ReceiptTypeName,
        ReceiptItemTypeId: refundCancelledType.ReceiptItemTypeId,
      },
      LastModifiedBy: currentUser.App_User_ID,
    })

    receiptCopy.Payments.push({
      ...defaultPayment,
      Amount: refundInfo.Amount * -1,
      Payor: { ...defaultPayment.Payor, Country: getUSADefault() },
      Type: {
        Description: depositAccountType.ReceiptTypeName,
        ReceiptItemTypeId: depositAccountType.ReceiptItemTypeId,
      },
      LastModifiedBy: currentUser.App_User_ID,
    })

    dispatch({ type: SET_RECEIPT, receipt: receiptCopy, originalReceipt: receipt })
    setPaymentsList(receiptCopy.Payments)
    setChargesList(receiptCopy.Charges)
    setCanEditCharges(false)
    setIsDirty(true)
    setRefundModal(false)
  }
  const emptyReceiptFields = () => {
    //Empty the receipt specific receipt fields
    let receiptCopy = {
      ...receipt,
      ReceiptID: null,
      ReceiptNum: null,
      Status: 'Unbalanced',
      StatusID: 516,
      Fields: {},
    }

    receiptCopy.Charges = receipt.Charges.map((item) => {
      item.ReceiptID = null
      item.ReceiptItemID = null
      return item
    })
    receiptCopy.Payments = receipt.Payments.map((item) => {
      item.ReceiptID = null
      item.ReceiptItemID = null
      return item
    })

    return receiptCopy
  }

  const moreButtonCSS = `
  height: 48px; 
  padding-top: 0px !important; 
  padding-bottom: 0px !important; 
  margin: 0px;
  div button {
    margin: 5px;
  }
  > button {
    max-height: 48px;
    margin: 0;
    
  }`
  const receiptReverse = () => {
    if (!appUserRights.includes('ReceiptReverse') )
    {
      dispatch(setErrorToast("Action denied"))
      return;
    }
    let receiptCopy = emptyReceiptFields()
    // set charge(s) to reverse the amount.
    receiptCopy.Charges = receipt.Charges.map((item) => {
      return {
        ...item,
        Amount: item.Amount * -1,
        Batch: null,
      }
    })
    // set original payment(s) to 0.00 amount
    let fullAmount = 0
    receiptCopy.Payments = receipt.Payments.map((item) => {
      fullAmount += item.Amount
      return {
        ...item,
        Amount: 0.0,
        Payor: item.payor ? null : { ...item.Payor },
        Batch: null,
      }
    })
    // create new payment with default type.
    const descr = receipt.Payments[0].Type.Description.toLowerCase()
    const itemTypeId = 
      descr.includes('credit card') && descr.includes('payment')
        ? reverseCreditCardReceiptItemId 
        : reverseCheckReceiptItemId
    const reverseType = (receiptItemTypes.Payments || []).find((type) => type.ReceiptItemTypeId == itemTypeId)
    if (!reverseType) {
      dispatch(
        setErrorToast(`Default reverse type not found in system. Contact admin to configure.`)
      )
      return
    }
    receiptCopy.Payments.push({
      ...defaultPayment,
      Amount: fullAmount * -1,
      Payor: null,
      Type: {
        Description: reverseType.Name,
        ReceiptItemTypeId: reverseType.ReceiptItemTypeId,
        CategoryID: 1,
      },
      LastModifiedBy: currentUser.App_User_ID,
    })

    dispatch({ type: SET_RECEIPT, receipt: receiptCopy, originalReceipt: receipt })
    setIsDirty(true)
    setShowRevert(true)
  }

  const isReverseReceiptDisabled = useMemo(() => {
    // LISA Said for PA it is only on Posted receipts.
    return receipt.Status !== 'Posted'
    // || paymentsList.find(item => item.Batch && item.Batch.PostNum)
    // || chargesList.find(item => item.Batch && item.Batch.PostNum)

    // return !isReceiptEditable
    // || !(paymentsList.find((payment) => {
    //   if (payment && payment.Batch)
    //     return !!payment.Batch.PostNum
    //   return false
    // }) || (chargesList.find((charge) => {
    //   if (charge && charge.Batch)
    //     return !!charge.Batch.PostNum
    //   return false
    // })))
  }, [receipt.Status /*isReceiptEditable, paymentsList, chargesList*/])

  const clickItemDelete = (item, index, type) => {
    setDisplayDeleteItemConfirmation(true)
    if (type === 'Payment') {
      setEditPayment(item)
      setEditCharge(null)
    }
    if (type === 'Charge') {
      setEditPayment(null)
      setEditCharge(item)
    }
    setEditIndex(index)
  }

  const cancelDeleteItem = () => {
    setDisplayDeleteItemConfirmation(false)
    setEditPayment(null)
    setEditCharge(null)
    setEditIndex(null)
  }

  const cancelRefundCancel = () => {
    setRefundModal(false)
  }

  const deleteItemFromList = () => {
    if (editPayment) {
      setPaymentsList(paymentsList.filter((item, index) => index !== editIndex))
    } else if (editCharge) {
      setChargesList(chargesList.filter((item, index) => index !== editIndex))
    }
    cancelDeleteItem()
    setIsDirty(true)
    setShowRevert(true)
  }

  return (
    <div className="receipt-validation">
      <React.Fragment>
        <div className="row receipt-header-row">
          <DetailCard
            label="Receipt Info"
            className="detailsCard"
            style={{ width: '60%', marginBottom: '10px' }}
          >
            <div className="row" style={{ display: 'flex', justifyContent: 'space-between' }}>
              <Detail label="Receipt #" /*children={receipt.ReceiptNum || "(New)"}*/>
                {receipt.ReceiptNum ? (
                  showPrintButton ? (
                    <span className="dln-link" onClick={printReceipt}>
                      {receipt.ReceiptNum}
                    </span>
                  ) : (
                    receipt.ReceiptNum
                  )
                ) : (
                  '(New)'
                )}
              </Detail>
              <Detail label="Status" children={receipt.Status || 'Unbalanced'} />
              <Detail
                label={'Date'}
                children={
                  receipt.Fields && receipt.Fields.RECEIPT_DATE
                    ? format(new Date(receipt.Fields.RECEIPT_DATE || null), 'MM/dd/yyyy hh:mm a')
                    : !receipt.ReceiptNum
                    ? '(New)'
                    : 'Missing'
                }
              />
              <ContextDataChip
                label="Balance"
                value={`${balanceValue < 0 ? '(' : ''}$${positiveBalanceValue
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${balanceValue < 0 ? ')' : ''}`}
                variant={balanceValue > 0 ? 'success' : balanceValue < 0 ? 'danger' : undefined}
              />
            </div>
          </DetailCard>
          <VoidInfoSection />
          {refundInfo && refundInfo.RefundStatusID && (
            <Refund
              refund={refundInfo}
              editMode={editRefundInfo}
              setEditMode={setEditRefundInfo}
              setRefund={setRefund}
              receiptStatus={receipt.StatusID}
              isDirty={isDirty}
            />
          )}
        </div>
        <div className="balance-receipt">
          <div className="payment-column">
            <div className="column-header ">
              {/* <div/> */}
              <h2>Payments</h2>
              <div className="total-detail-header">
                <ContextDataChip
                  label="Total Payments"
                  value={`${totalPayments >= 0 ? '' : `(`}$${(totalPayments < 0
                    ? totalPayments * -1
                    : totalPayments
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${totalPayments >= 0 ? '' : `)`}`}
                  variant={totalPayments >= 0 ? 'success' : 'danger'}
                />
                {/* <ButtBox hideCheckbox={true} onClick={() => {openPaymentModal()}} customCss={{marginLeft: '10px'}} icon={<div style={{display: 'flex', alignSelf: 'center', width: '18px', paddingLeft: '0px',}}><PlusIcon /></div>}/> */}
              </div>
            </div>
            {paymentsList.map((item, i) => {
              return (
                <ReceiptPayment
                  key={i}
                  paymentItem={item}
                  paymentIndex={i}
                  updateItem={openPaymentModal}
                  isEditable={isReceiptEditable}
                  failedValidation={failedValidation}
                  deleteItem={clickItemDelete}
                />
              )
            })}
            {showAddReceiptItems && !loadingWorkviewPayment && (
              <div
                className={`new-item-box ${isReceiptEditable ? '' : 'disabled'}`}
                onClick={() => (isReceiptEditable ? openPaymentModal() : null)}
              >
                <div className="new-item-content">
                  <PlusIcon />
                  <p>Add New Payment</p>
                </div>
              </div>
            )}
            {loadingWorkviewPayment && (
              <Spinner className="page-loader" themeColor="dark-neutral" />
            )}
          </div>
          <div className="charge-column">
            <div className="column-header">
              {/* <div/> */}
              {/* <ButtBox label={`Add Charge`} hideCheckbox={true} onClick={() => {}}  icon={<div style={{display: 'flex', alignSelf: 'center', width: '18px', paddingRight: '5px'}}><PlusIcon /></div>}/> */}
              <h2>Charges</h2>
              <div className="total-detail-header">
                <ContextDataChip
                  label="Total Charges"
                  value={`${totalCharges >= 0 ? '' : `(`}$${(totalCharges < 0
                    ? totalCharges * -1
                    : totalCharges
                  )
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}${totalCharges >= 0 ? '' : `)`}`}
                  variant={totalCharges >= 0 ? 'success' : 'danger'}
                />
                {/* <ButtBox hideCheckbox={true} onClick={() => {openChargeModal()}} customCss={{marginLeft: '10px'}} icon={<div style={{display: 'flex', alignSelf: 'center', width: '18px', paddingLeft: '0px',}}><PlusIcon /></div>}/> */}
              </div>
            </div>
            {chargesList.map((item, i) => {
              return (
                <ReceiptCharge
                  key={i}
                  chargeItem={item}
                  chargeIndex={i}
                  updateItem={openChargeModal}
                  isEditable={isReceiptEditable && canEditCharges}
                  deleteItem={clickItemDelete}
                />
              )
            })}
            {showAddReceiptItems && (
              <div
                className={`new-item-box ${isReceiptEditable ? '' : 'disabled'}`}
                onClick={() => (isReceiptEditable ? openChargeModal() : null)}
              >
                <div className="new-item-content">
                  <PlusIcon />
                  <p>Add New Charge</p>
                </div>
              </div>
            )}
          </div>
        </div>
        {loadingExisting ? <Spinner className="page-loader" themeColor="dark-neutral" /> : null}

        <div className="context-bar-wrapper receipt-context-bar-wrapper">
          <ContextBar>
            <div className="context-button-wrapper">
              <ContextButton
                onClick={revertReceipt}
                className={`${!showRevert ? 'hidden' : ''}`}
                disabled={!isDirty || saveInProgress}
                customCss={'max-height: 48px'}
                leftIcon={
                  <div className="checkmark-wrapper left">
                    <Revert />
                  </div>
                }
                variant="danger"
              >
                Revert
              </ContextButton>
              <ContextButton
                onClick={() => {
                  history.key ? history.goBack() : history.push('/office/workview')
                }}
                variant="secondary"
                className={`${!showBackButton ? 'hidden' : ''}`}
                customCss={'max-height: 48px'}
                leftIcon={
                  <div className="checkmark-wrapper left">
                    <LeftArrowIcon />
                  </div>
                }
              >
                Back
              </ContextButton>
              <ContextButton
                onClick={printReceipt}
                variant="primary"
                className={`${!showPrintButton ? 'hidden' : ''}`}
                customCss={'max-height: 48px'}
                rightIcon={
                  <div className="checkmark-wrapper right">
                    <PrintIcon />
                  </div>
                }
              >
                Print
              </ContextButton>
              {appUserRights.includes('ReceiptCreate') && (
                <ContextButton
                  onClick={saveReceipt}
                  disabled={disableSaveButton || saveInProgress}
                  customCss={'max-height: 48px'}
                  rightIcon={
                    <div className="checkmark-wrapper right">
                      <RightArrowIcon />
                    </div>
                  }
                  variant="primary"
                >
                  Save
                </ContextButton>
              )}
              {saveInProgress && (
                <div style={{ marginTop: '20px', marginLeft: '20px', marginRight: '20px' }}>
                  <Spinner size="small" themeColor="dark-neutral" />
                </div>
              )}
              {appUserRights.length > 0 && receipt.Payments && (
                <MoreOptionsButton
                  label="More"
                  customCss={moreButtonCSS}
                  className={`context-bar-item more-button ${
                    !moreButtonRights || !displayMoreButton ? 'hidden' : ''
                  }`}
                >
                  <div
                    style={{
                      padding: '10px',
                    }}
                  >
                    {appUserRights.includes('ReceiptVoid') && (
                      <ContextButton
                        onClick={() => {
                          setVoidModalOpen(true)
                        }}
                        customCss={'max-height: 48px'}
                        className={`more-button-content ${!showVoidButton ? 'hidden' : ''}`}
                        leftIcon={
                          <div className="checkmark-wrapper left">
                            <CrossHeavy />
                          </div>
                        }
                        variant="danger"
                        disabled={saveInProgress}
                      >
                        Void
                      </ContextButton>
                    )}

                    {appUserRights.includes('ReceiptCreate') && appUserRights.includes('ReceiptReverse') && (
                      <ContextButton
                        className="more-button-content"
                        onClick={receiptReverse}
                        disabled={isReverseReceiptDisabled || saveInProgress}
                        leftIcon={
                          <div className="checkmark-wrapper left">
                            <ReceiptCancel />
                          </div>
                        }
                      >
                        Reverse Receipt
                      </ContextButton>
                    )}
                    {appUserRights.includes('ReceiptCreate') &&
                      receipt.Status === 'Posted' &&
                      receipt.Payments[0] &&
                      receipt.Payments[0].Type &&
                      (receipt.Payments[0].Type.Description.includes('Check/MO') ||
                        receipt.Payments[0].Type.Description.includes('ACH')) && (
                        <ContextButton
                          onClick={replacementCheck}
                          disabled={saveInProgress}
                          leftIcon={
                            <div className="checkmark-wrapper left">
                              <Clone />
                            </div>
                          }
                        >
                          Replacement Check
                        </ContextButton>
                      )}
                  </div>
                </MoreOptionsButton>
              )}
            </div>
          </ContextBar>
        </div>
        <Portal isOpened={paymentModalOpen}>
          <Modal
            title={editPayment && editPayment.Type ? 'Edit Payment' : 'Add Payment'}
            modalSize="extra-large"
            cancelButton
            autoHeight
            closeModal={() => {
              setPaymentModalOpen(false)
              setEditIndex(null)
              setEditPayment(null)
            }}
          >
            <PaymentModal
              payment={editPayment}
              receiptNum={receipt.ReceiptNum}
              clickUpdate={updatePaymentItem}
              editIndex={editIndex}
              closeModal={() => {
                setPaymentModalOpen(false)
                setEditIndex(null)
                setEditPayment(null)
              }}
              paymentsList={paymentsList}
            />
          </Modal>
        </Portal>
        <Portal isOpened={chargeModalOpen}>
          <Modal
            title={editCharge && editCharge.Type ? 'Edit Charge' : 'Add Charge'}
            modalSize="extra-large"
            cancelButton
            autoHeight
            closeModal={() => {
              setChargeModalOpen(false)
              setEditIndex(null)
              setEditCharge(null)
            }}
          >
            <ChargeModal
              charge={editCharge}
              clickUpdate={updateChargeItem}
              closeModal={() => {
                setChargeModalOpen(false)
                setEditIndex(null)
                setEditCharge(null)
              }}
            />
          </Modal>
        </Portal>
        <Portal isOpened={displayUnbalancedError}>
          <Modal
            title={'Valid Input is Required'}
            cancelButton
            autoHeight
            closeModal={() => setDisplayUnbalancedError(false)}
          >
            <div className="save-error-message">The receipt must balance to zero.</div>
            <div className="save-error-message">
              <ContextButton onClick={() => setDisplayUnbalancedError(false)} variant="secondary">
                Ok
              </ContextButton>
            </div>
          </Modal>
        </Portal>
        <Portal isOpened={displayBalanceError}>
          <Modal
            title={'Valid Input is Required'}
            cancelButton
            autoHeight
            closeModal={() => setDisplayBalanceError(false)}
          >
            <div className="save-error-message">
              The Receipt cannot be saved while the{' '}
              <span style={{ color: 'hsl(127,100%,29%)' }}>payment total</span> is less than the{' '}
              <span style={{ color: 'hsl(345,100%,42%)' }}>charges total</span>.
            </div>
            <div className="save-error-message">
              <ContextButton onClick={() => setDisplayBalanceError(false)} variant="secondary">
                Ok
              </ContextButton>
            </div>
          </Modal>
        </Portal>
        <Portal isOpened={displayEmptyReceiptError}>
          <Modal
            title={'Valid Input is Required'}
            cancelButton
            autoHeight
            closeModal={() => setDisplayEmptyReceiptError(false)}
          >
            <div className="save-error-message">
              The Receipt cannot be saved without a minimum of 1 payment or 1 charge.
            </div>
            <div className="save-error-message">
              <ContextButton onClick={() => setDisplayEmptyReceiptError(false)} variant="secondary">
                Ok
              </ContextButton>
            </div>
          </Modal>
        </Portal>
        <Portal isOpened={displayWorkviewBalanceError}>
          <Modal
            title={'$0.00 Balance is Required'}
            cancelButton
            autoHeight
            closeModal={() => setDisplayWorkviewBalanceError(false)}
          >
            <div className="save-error-message">
              The Receipt must have at least one charge and a $0.00 balance to close the Workview
              Item.
            </div>
            <div className="save-error-message">
              <ContextButton
                onClick={() => setDisplayWorkviewBalanceError(false)}
                variant="secondary"
              >
                Ok
              </ContextButton>
            </div>
          </Modal>
        </Portal>
        <Portal isOpened={voidModalOpen}>
          <Modal
            title={'Void Receipt'}
            cancelButton
            autoHeight
            modalSize={'large'}
            closeModal={closeVoidReasonPopup}
          >
            <div className="void-receipt-popup">
              <TextInput
                label={
                  <span>
                    Reason to Void Receipt<span style={{ color: `hsl(345,100%,42%)` }}>*</span>
                  </span>
                }
                value={voidReason}
                onChange={(e) => {
                  setVoidReason(e.target.value)
                }}
                valid={voidPopupError && !voidReason ? false : undefined}
                errorMessage={voidPopupError && !voidReason ? 'Required Field' : undefined}
              />
              <div className="save-error-message">
                <ContextButton variant="secondary" onClick={closeVoidReasonPopup}>
                  Cancel
                </ContextButton>
                <ContextButton
                  disabled={!voidReason}
                  onClick={() => {
                    if (!voidReason) {
                      setVoidPopupError(true)
                    } else {
                      // call void endpoint.
                      dispatch(
                        voidReceipt({
                          ReceiptNum: receipt.ReceiptNum,
                          Reason: voidReason,
                          Action: 'VOID',
                        })
                      )
                      closeVoidReasonPopup()
                    }
                  }}
                  variant="danger"
                >
                  Void
                </ContextButton>
              </div>
            </div>
          </Modal>
        </Portal>
        <Portal isOpened={displayDeleteItemConfirmation}>
          <Modal
            title={'Delete Receipt Item'}
            cancelButton
            autoHeight
            closeModal={cancelDeleteItem}
          >
            <div className="save-error-message">
              Are you sure you want to delete this receipt item?
            </div>
            <div className="confirm-buttons-wrapper">
              <ContextButton onClick={deleteItemFromList} variant="success">
                Yes
              </ContextButton>
              <ContextButton onClick={cancelDeleteItem} variant="danger">
                No
              </ContextButton>
            </div>
          </Modal>
        </Portal>
        <Portal isOpened={refundModal}>
          <Modal title={'Cancelled Refund'} autoHeight closeModal={cancelRefundCancel}>
            <RefundModal
              skipCancelledReceipt={cancelRefundCancel}
              createCancelledReceipt={createCancelRefundReceipt}
            />
          </Modal>
        </Portal>
      </React.Fragment>
    </div>
  )
}

export default ReceiptValidation

const VoidInfoSection = () => {
  const { receipt } = useSelector((state) => state.receipt, shallowEqual)
  const info = receipt.VoidReason || {}
  // {
  //   Date: new Date(),
  //   PrimaryAppUserName: 'Test One',
  //   SecondaryAppUserName: 'Test Two',
  //   Reason: 'This is a test\nreason\nSo we can see this works'
  // };
  const word = useMemo(() => {
    return info.VoidDeleteTypeId === 0 ? 'Void' : 'Delete'
  }, [info])

  return info && info.Date ? (
    <DetailCard
      label={`${word} Information`}
      className="detailsCard"
      style={{ width: '60%', marginBottom: '10px' }}
    >
      <div className="ucc-row" style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Detail label={`${word} Date`}>{format(new Date(info.Date), `MM/dd/yyyy hh:mm a`)}</Detail>
        <Detail label={`${word === 'Void' ? word + 'e' : word}d By`}>
          {info.PrimaryAppUserName}
        </Detail>
        {info.SecondaryAppUserName && (
          <Detail label={`Confirmed By`}>{info.SecondaryAppUserName}</Detail>
        )}
      </div>
      <div className="ucc-row">
        <Detail label={`Reason`} customCss={{ whiteSpace: 'pre-wrap' }}>
          {info.Reason}
        </Detail>
      </div>
    </DetailCard>
  ) : null
}
